"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.actions = {
    REQUEST_MOVIE_INFO: 'REQUEST_MOVIE_INFO',
    FETCH_MOVIE_INFO_SUCCESS: 'FETCH_MOVIE_INFO_SUCCESS',
    PUT_MOVIE_INFO: 'PUT_MOVIE_INFO',
};
exports.actionCreators = {
    requestMovieInfo: () => ({
        type: exports.actions.REQUEST_MOVIE_INFO
    }),
    fetchMovieInfo: (ediNumber) => ({
        type: exports.actions.FETCH_MOVIE_INFO_SUCCESS,
        ediNumber
    }),
    putMovieInfo: (movieInfo) => ({
        type: exports.actions.PUT_MOVIE_INFO,
        movieInfo
    }),
};



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-website-store/movie/actions.ts